import {
    mapState,
} from 'vuex'

const myPlugin = {
    install(Vue) {
        Vue.mixin({
          data() {
            const api = process.env.VUE_APP_DEPLOYMENT == 'TEST' ? process.env.VUE_APP_ICHIJO_TEST_API : process.env.VUE_APP_ICHIJO_API
              return {
                cognitoApi: process.env.VUE_APP_COGNITO_API + 'transaction/',
                ichijoApi: api,
                ichijoLegacyApi: api + 'legacy-login',
                ichijoLegacyApiKey: {
                  headers: {
                    "Content-Type": "application/json",
                    "x-api-key": process.env.VUE_APP_DEPLOYMENT == 'TEST' ? process.env.VUE_APP_ICHIJO_TEST_API_KEY : process.env.VUE_APP_ICHIJO_API_KEY,
                  }
                },
                windowSize: {
                  x: 0,
                  y: 0
                },
              }
          },//end of data
          methods: {
              onResize() {
                this.windowSize = { x: window.innerWidth, y: window.innerHeight }
              },
              parseJwt (token) {
                var base64Url = token.split('.')[1];
                var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                }).join(''));
                return JSON.parse(jsonPayload);
              }
          },
          computed: {
              ...mapState([
                    'userInfo',
              ])
          }
        })
    }
}
    export default myPlugin